import { AxiosError } from 'axios';

export type BackendErrorContainer = {
  status?: number;
  title?: string;
  requestId?: string;
};

/**
 * Función para extraer el mensaje y el código
 * correspondiente a una respuesta de error de un request
 * de Axios.
 */
export const axiosMessageExtractor = (axiosError: AxiosError<BackendErrorContainer, any>) => {
  if (!axiosError?.response?.data?.title && !axiosError?.response?.data?.requestId) return undefined;

  return {
    message: axiosError?.response?.data?.title,
    code: axiosError?.response?.data?.requestId,
  };
};
